export default __webpack_public_path__ + "static/cracking-code-fffa2926042e440693c15015a0e665de.png";